import React,{Component} from 'react';
import Main from './components/MainComponent';
import './App.css';




const App = () => {

  return(
    <div>
      <Main/>
    </div>
    );

}
export default App;